import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

// *: both plugins are registered here, next to the only formatters that need them, so
// *: the side effect travels with its consumer instead of sitting in the lib barrel.
momentDurationFormatSetup(moment);

dayjs.extend(duration);

/**
 * Expresses how long ago a device first went into service as a human-readable lifetime. Diffs the given date against now with dayjs, then renders years plus months when at least a year has elapsed, otherwise months plus days, singularising each unit and falling back to `'< 1 day'`.
 *
 * @param date - Start date to measure the elapsed lifetime from.
 * @returns Lifetime string built from the elapsed years, months or days.
 */
const formatEndOfLife = (date: any) => {
  const timeDiff = dayjs().diff(dayjs(date));
  const year = dayjs.duration(timeDiff).years();
  const month = dayjs.duration(timeDiff).months();
  const day = dayjs.duration(timeDiff).days();
  if (year > 0) {
    return (
      (year ? year + (year > 1 ? ' years ' : ' year ') : '') +
      (month ? month + (month > 1 ? ' months ' : ' month ') : '')
    );
  }
  return (
    (month ? month + (month > 1 ? ' months ' : ' month ') : '') +
    (day ? day + (day > 1 ? ' days ' : ' day') : '< 1 day')
  );
};

/**
 * Renders a numeric duration into a display string using a moment duration format pattern. Builds a moment duration from the value in the given unit (minutes by default) and formats it, passing stopTrim through so leading zero units can be kept.
 *
 * @param duration - Numeric duration value.
 * @param format - Moment duration format pattern to render with.
 * @param stopTrim - Units that must not be trimmed from the formatted output.
 * @param unit - Unit the duration value is expressed in.
 * @returns Formatted duration string.
 */
const getDuration = (duration: any, format: any, stopTrim: any = undefined, unit = 'minutes') =>
  moment.duration(duration, unit as any).format(format, { stopTrim });

export { formatEndOfLife, getDuration };
